/*
 * @Descripttion:
 * @Author: baiyang
 * @Date: 2022-01-06 19:03:53
 * @LastEditors: baiyang
 * @LastEditTime: 2022-03-08 17:00:26
 */
import http from './http'

/**
 * 获取弹窗优惠券
*/
export const getMaskCoupon = function (params) { return http('pay_ad/v2/ad_im', params) }

/**
 * 领券结果上报
*/
export const sendCouponResult = function (params) { return http('pay_ad/v2/ad_busifavor_ping', params) }

/**
 * 获取当前模块的优惠券
*/
export const getCoupon = function (params) { return http('pay_ad/v2/ad_busifavor', params) }

/**
 * 获取打开券详情参数
*/
export const getOpenCouponParams = function (params) { return http('pay_ad/v2/ad_open_card', params) }

/**
 * 获取组件页面展示数据上报
 */
export const getOpenCouponDataReport = function (params) { return http('pay_ad/v2/data_report', params) }
/**
 * @function 曝光统计方式
 * @author by
 */
export const getDataReportType = function (params) { return http('pay_ad/v2/data_report_type', params) }
